import { render, staticRenderFns } from "./DocenteNuevo.vue?vue&type=template&id=322cd173&"
import script from "./DocenteNuevo.vue?vue&type=script&lang=js&"
export * from "./DocenteNuevo.vue?vue&type=script&lang=js&"
import style0 from "./DocenteNuevo.vue?vue&type=style&index=0&id=322cd173&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports